// channelFieldToDBFieldMap maps the channel's field name (from UI) to the db field name (mysql).
// Add to this map for the paginated order using the ListTable component.
import { ISmallSite } from '~/src/dash/api/channels/channels_models';
import { createUrl, createUrlPublicaMonitors, restGet } from '~/src/dash/api/rest';

export const channelFieldToDBFieldMap: { [key: string]: string } = {
  Active: 'active',
  Name: 'name',
  FloorPrice: 'bid_floor',
  Last24HrImpressions: 'last_24_hr_impressions',
  PastWeekImpressions: 'past_week_impressions',
  Last24HrAverageCPM: 'last_24_hr_average_cpm',
  PastWeekAverageCPM: 'past_week_average_cpm',
  Last24HrRevenue: 'last_24_hr_revenue',
  PastWeekRevenueSites: 'past_week_revenue',
  Last24HrEndpointRequests: 'last_24_hr_endpoint_requests',
  PastWeekEndpointRequests: 'past_week_endpoint_requests',
};

export async function getSmallSites(
  publisherID: string,
  otherFields?: string,
): Promise<[ISmallSite[] | undefined, string | undefined]> {
  let reqUrl = createUrl('/small_sites', publisherID, 'v2');
  if (otherFields !== undefined) {
    reqUrl = `${reqUrl}&other_fields=${otherFields}`;
  }

  try {
    return [(await restGet<ISmallSite[]>(reqUrl)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}

export async function getSmallSitesByPublisherIDs(
  publisherIDs: string,
  otherFields?: string,
): Promise<[ISmallSite[] | undefined, string | undefined]> {
  let reqUrl = createUrlPublicaMonitors('/small_sites_by_publisher_ids', publisherIDs, 'v2');
  if (otherFields !== undefined) {
    reqUrl = `${reqUrl}&other_fields=${otherFields}`;
  }

  try {
    return [(await restGet<ISmallSite[]>(reqUrl)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}
